<!-- <p-dialog [visible]="true" [modal]="true" styleClass="cus-dialog-md cus-dialog alert-dialog account-aggregator" [closable]="false" [draggable]="false" [resizable]="false"> -->
<div class="account-aggregator-content">
    <iframe #iframe></iframe>
</div>
<!-- </p-dialog> -->